export const SET_FLY_OBJECT = "SET_FLY_OBJECT";
export const SET_FLY_AREA = "SET_FLY_AREA";